import { IconOnTheLeftWithContentLayout } from '@/app/(marketing-site)/mentoring/_layouts/IconOnTheLeftWithContentLayout'
import { P3 } from '@/frontend/design-system/_marketing/typography/Paragraph/P3'

export const BENEFITS = [
  'Nielimitowany dostęp do kursów grupowych AlgoAcademy - zapisy na kursy są bezpłatne dla mentorowanych',
  'Indywidualny plan rozwoju dostosowany do Twoich umiejętności, celów, i zainteresowań oraz nielimitowaną możliwość aktualizacji',
  'Regularne konsultacje z mentorem co 2 tygodnie',
  'Zadania i projekty indywidualnie dobrane przez mentora',
  'Nielimitowany kontakt z mentorem przez czat (czas oczekiwania na odpowiedź do 48 godzin)',
  'Regularne monitorowanie postępów'
]

export function BasicMentoringOptions() {
  return (
    <>
      {BENEFITS.map(text => (
        <IconOnTheLeftWithContentLayout key={text} mainContent={<P3>{text}</P3>} />
      ))}
    </>
  )
}
